import React, { useMemo } from "react";
import CustomSelect from "components/CustomSelect";
import allJudetTownRO from "data/allJudetTownRO";
import CustomInput from "components/CustomInput";
import judetePremierJSON from "data/judetePremier";
import TextInfo from "components/TextInfo";
import { removeDiacritics } from "helpers/helpers";
import { removeDiacriticsToUppercase } from "helpers/helpers";

export default function Adresa({
   formularCorespondenta,
   judetePremier,
   title,
   type,
   textInfoTitle,
   hoverText,
   formikValues,
   setFieldValue,
   formikErrors,
   formikTouched,
   handleChange,
   isDisabled,
}) {
   const tipStrada = [
      { value: "Strada", label: "Strada" },
      { value: "Bulevardul", label: "Bulevardul" },
      { value: "Soseaua", label: "Soseaua" },
      { value: "Splaiul", label: "Splaiul" },
      { value: "Calea", label: "Calea" },
      { value: "Aleea", label: "Aleea" },
      { value: "Intrarea", label: "Intrarea" },
   ];

   //citesc judetele din fisierul allJudetTownRO.js
   const judeteFiltrate = useMemo(
      () =>
         [...new Set(allJudetTownRO.judete.map(item => item.nume))].map(judet => {
            return { value: removeDiacritics(judet), label: judet };
         }),
      [allJudetTownRO.judete],
   );

   // filtrez localitatile in functie de judetul selectat
   const localitatiFiltrate = useMemo(() => {
      const localitati = allJudetTownRO.judete.filter(localitati => removeDiacriticsToUppercase(localitati.nume) === formikValues.judet);

      return localitati.map(item => {
         return item.localitati.map(localitate => {
            return { value: removeDiacriticsToUppercase(localitate.nume), label: localitate.nume };
         });
      });
   }, [allJudetTownRO.judete, formikValues.judet]);

   /* Filtrare fara diacritice */

   const judeteFiltratePremier = useMemo(
      () =>
         [...new Set(judetePremierJSON.map(item => item.judetLong))].map(judetLong => {
            return { value: judetLong, label: judetLong };
         }),
      [],
   );

   const localitatiFiltratePremier = useMemo(() => {
      const localitati = judetePremierJSON.filter(judet => judet.judetLong === formikValues.judet);
      return localitati.map(item => {
         return { value: item.localitate, label: item.localitate, codSIRUTA: item.codSIRUTA };
      });
   }, [formikValues.judet]);

   const flexPostCodeLabel = formularCorespondenta && "label-obligatoriu";

   return (
      <>
         {textInfoTitle ? (
            <div>
               <TextInfo
                  containerClassNames={"text-info-container d-flex align-items-center mb-3"}
                  textClassNames={"mb-0 contr-sub d-flex align-items-center"}
                  text={title}
                  hoverText={hoverText}
               />
            </div>
         ) : (
            <p className="contr-sub mt-30 text-info-container">{title}</p>
         )}

         <div className="row row-input mt-50">
            <div className="col-md-6 mb-768">
               <CustomSelect
                  options={judetePremier === true ? judeteFiltratePremier : judeteFiltrate}
                  value={formikValues.judet}
                  onChange={value => {
                     setFieldValue(`${type}.judet`, value.value);
                     setFieldValue(`${type}.localitate`, "");
                  }}
                  placeholder="Alege Județul..."
                  id={`${type}.judet`}
                  isError={formikErrors?.judet && formikTouched?.judet}
                  name={`${type}.judet`}
                  labelDescription={"Județul"}
                  obligatoriu={true}
                  isDisabled={isDisabled}
               />
               {formikErrors?.judet && formikTouched?.judet ? <div className="error-msg">{formikErrors?.judet}</div> : null}
            </div>
            <div className="col-md-6">
               <CustomSelect
                  options={judetePremier === true ? localitatiFiltratePremier : localitatiFiltrate[0]}
                  value={formikValues.localitate}
                  onChange={value => {
                     setFieldValue(`${type}.localitate`, value.value);
                     setFieldValue(`${type}.codSIRUTA`, value?.codSIRUTA);
                  }}
                  placeholder="Alege Localitatea..."
                  id={`${type}.localitate`}
                  isError={formikErrors?.localitate && formikTouched?.localitate}
                  name={`${type}.localitate`}
                  labelDescription={"Localitatea"}
                  obligatoriu={true}
                  isDisabled={isDisabled}
               />
               {formikErrors?.localitate && formikTouched?.localitate ? <div className="error-msg">{formikErrors?.localitate}</div> : null}
            </div>
         </div>
         <div className="row row-input mt-30">
            <div className="col-md-6 mb-768">
               <CustomSelect
                  options={tipStrada}
                  value={formikValues.tipStrada}
                  onChange={value => setFieldValue(`${type}.tipStrada`, value.value)}
                  placeholder="Alege tipul străzii..."
                  id={`${type}.tipStrada`}
                  name={`${type}.tipStrada`}
                  isError={formikErrors?.tipStrada && formikTouched?.tipStrada}
                  labelDescription={"Tip Stradă"}
                  obligatoriu={true}
               />
               {formikErrors?.tipStrada && formikTouched?.tipStrada ? <div className="error-msg">{formikErrors?.tipStrada}</div> : null}
            </div>
            <div className="col-md-6">
               <label className="d-lg-block d-sm-flex d-column" htmlFor={`${type}.strada`}>
                  Nume Stradă<span className="optional"> (obligatoriu)</span>
               </label>
               <CustomInput
                  id={`${type}.strada`}
                  type={"text"}
                  value={formikValues.strada}
                  setFieldValue={setFieldValue}
                  error={formikErrors?.strada}
                  touched={formikTouched?.strada}
                  name={`${type}.strada`}
               />
            </div>
         </div>
         <div className="row row-input mt-30">
            <div className="col-md-4 col-6 my-2 optional_container">
               <label className="numar-label" htmlFor={`${type}.numar`}>
                  Număr <span className="optional"> (opțional)</span>
               </label>
               <CustomInput
                  id={`${type}.numar`}
                  name={`${type}.numar`}
                  type={"text"}
                  value={formikValues.numar}
                  setFieldValue={setFieldValue}
                  error={formikErrors?.numar}
                  touched={formikTouched?.numar}
               />
            </div>
            <div className="col-md-4 col-6 my-2 optional_container">
               <label htmlFor={`${type}.bloc`}>
                  Bloc<span className="optional"> (opțional)</span>
               </label>
               <CustomInput
                  id={`${type}.bloc`}
                  name={`${type}.bloc`}
                  type={"text"}
                  value={formikValues.bloc}
                  setFieldValue={setFieldValue}
                  error={formikErrors?.bloc}
                  touched={formikTouched?.bloc}
               />
            </div>
            <div className="col-md-4 col-6 my-2 optional_container">
               <label htmlFor={`${type}.scara`}>
                  Scară <span className="optional"> (opțional)</span>
               </label>
               <CustomInput
                  id={`${type}.scara`}
                  name={`${type}.scara`}
                  type={"text"}
                  value={formikValues.scara}
                  setFieldValue={setFieldValue}
                  error={formikErrors?.scara}
                  touched={formikTouched?.scara}
               />
            </div>

            <div className="col-md-4 col-6 my-2 optional_container">
               <label className="etaj-label" htmlFor={`${type}.etaj`}>
                  Etaj <span className="optional"> (opțional)</span>
               </label>
               <CustomInput
                  id={`${type}.etaj`}
                  name={`${type}.etaj`}
                  type={"text"}
                  value={formikValues.etaj}
                  setFieldValue={setFieldValue}
                  error={formikErrors?.etaj}
                  touched={formikTouched?.etaj}
               />
            </div>
            <div className="col-md-4 col-6 my-2 optional_container">
               <label className={flexPostCodeLabel} htmlFor={`${type}.apartament`}>
                  Apartament <span className="optional"> (opțional)</span>
               </label>
               <CustomInput
                  id={`${type}.apartament`}
                  name={`${type}.apartament`}
                  type={"text"}
                  value={formikValues.apartament}
                  setFieldValue={setFieldValue}
                  error={formikErrors?.apartament}
                  touched={formikTouched?.apartament}
               />
            </div>
            <div className="col-md-4 col-6 my-2 optional_container">
               <label className={`cod-postal-label ${flexPostCodeLabel}`} htmlFor={`${type}.codPostal`}>
                  Cod poștal <span className="optional"> ({formularCorespondenta ? "obligatoriu" : "opțional"})</span>
               </label>
               <CustomInput
                  id={`${type}.codPostal`}
                  name={`${type}.codPostal`}
                  type={"text"}
                  value={formikValues.codPostal}
                  setFieldValue={setFieldValue}
                  error={formikErrors?.codPostal}
                  touched={formikTouched?.codPostal}
                  maxLengthNumber={6}
                  preventLetters={true}
               />
            </div>
         </div>
      </>
   );
}
